module.exports = __webpack_public_path__ + "e04541cdd0439f980ba9591d799201b5.pdf";